import React from "react";
import { stylex } from "./stylex";
import { cssVariables } from "./css_variables";
import { Text } from "./text";
import { Pressable } from "./pressable";

interface Option<TValue = any> {
  label: string;
  value: TValue;
}

interface SegmentedControlProps<TValue = any> {
  testID?: string;
  value?: TValue;
  onChange?: (value: TValue) => void;
  options?: Option<TValue>[];
}

export function SegmentedControl(props: SegmentedControlProps) {
  const { value, onChange = () => {}, options = [], testID } = props;

  return (
    <div style={styles("root")} data-testid={testID}>
      {options.map((option, index) => {
        const first = index === 0;
        const last = index === options.length - 1;
        const selected = value === option.value;

        return (
          <Pressable
            key={option.value}
            style={styles(
              "control",
              selected && "selected",
              first && "first",
              last && "last"
            )}
            onPress={() => onChange(option.value)}
          >
            <Text color="primary">{option.label}</Text>
          </Pressable>
        );
      })}
    </div>
  );
}

const styles = stylex.create({
  root: {
    display: "flex",
  },
  control: {
    borderRight: `1px solid ${cssVariables.borderColorPrimary}`,
    borderTop: `1px solid ${cssVariables.borderColorPrimary}`,
    borderBottom: `1px solid ${cssVariables.borderColorPrimary}`,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    flex: 1,
    height: 40,
    paddingLeft: 24,
    paddingRight: 24,
  },
  first: {
    borderLeft: `1px solid ${cssVariables.borderColorPrimary}`,
    borderTopLeftRadius: cssVariables.radius,
    borderBottomLeftRadius: cssVariables.radius,
  },
  last: {
    borderTopRightRadius: cssVariables.radius,
    borderBottomRightRadius: cssVariables.radius,
  },
  selected: {
    backgroundColor: cssVariables.backgroundLightPrimary,
  },
});
